'use client';

export { default } from './Avatar';
export { default as avatarClasses } from './avatarClasses';
export * from './avatarClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Avatar/index.js
// module id = 486
// module chunks = 25